import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.highlightActiveLink();
  }

  highlightActiveLink() {
    const currentUrl = new URL(window.location.href);
    const activeLink = this.linkTargets
      .filter((link) => this.matchesCurrentUrl(link, currentUrl))
      .sort((a, b) => this.filterCount(b) - this.filterCount(a))[0];

    this.setActive(activeLink);
  }

  highlight(event) {
    this.setActive(event.currentTarget);
  }

  setActive(activeLink) {
    this.linkTargets.forEach((link) => {
      if (link === activeLink) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  matchesCurrentUrl(link, currentUrl) {
    const linkUrl = new URL(link.href);

    return linkUrl.pathname === currentUrl.pathname &&
      [...linkUrl.searchParams].every(([name, value]) => currentUrl.searchParams.get(name) === value);
  }

  filterCount(link) {
    return [...new URL(link.href).searchParams].length;
  }
}
